module.exports = __webpack_public_path__ + "img/1.76582e1d.jpg";